import { domain } from 'modules/data';

export const pageConfig = {
    access: [domain.CompanyUserRole.Manager],
    integrationTypes: [domain.IntegrationType.NetSuite],
};
